import React from "react";

// Component
import AnimatedText from "../HomeSection/AnimatedText";

//Assets
import game from "../../Assets/game.mp4";

function ProductIntro() {
  const landingText = {
    type: "container",
    text: "Game",
  };
  const landingText2 = {
    type: "container",
    text: "A world of possibilities",
  };
  return (
    <div className="productsSection_intro">
      <div className="productsSection_intro_title">
        <div>
          <AnimatedText {...landingText} delay={0} />
        </div>
        <div>
          <AnimatedText {...landingText2} delay={0} />
        </div>
      </div>
      <video loop autoPlay={true} muted>
        <source src={game} type="video/mp4" />
      </video>
    </div>
  );
}

export default ProductIntro;
